import {
  FileOutlined,
  UserOutlined,
  ScheduleOutlined,
  UsergroupAddOutlined,
  CarryOutOutlined,
  LineChartOutlined,
  CoffeeOutlined,
  SettingOutlined,
  MessageOutlined,
  SmileOutlined,
  ContainerOutlined,
  HomeOutlined,
  TrophyOutlined,
  InfoCircleOutlined,
  ReadOutlined,
  HeartOutlined,
  BookOutlined,
  DeleteOutlined,
  MenuOutlined,
} from "@ant-design/icons";
import {
  useWindowSize,
  useWindowWidth,
  useWindowHeight,
} from "@react-hook/window-size";
import { Avatar, Badge, Space } from "antd";
import AddElev from "../Pages/Admin/AddElev";
import { Breadcrumb, Layout, Menu, theme, Image } from "antd";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import Chats from "../Pages/Chats/View";
import { useSelector } from "react-redux";
import ProfileElevi from "../Pages/Admin/ProfileElevi";
import { getDocs, collection, onSnapshot } from "firebase/firestore";
import { useEffect } from "react";
import { db } from "../database/firebase";
import MobileBottomNavigation from "./MobileBottomNavigation";
import "./MobileNavigation.css";
const { Header, Content, Footer, Sider } = Layout;

function getItem(label, key, icon, children) {
  return {
    key,
    icon,
    children,
    label,
  };
}

const Navbar = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [openSearch, setOpenSearch] = useState(false);
  const user = useSelector((state) => state.user);
  const [width, height] = useWindowSize();
  const [open, setOpen] = useState(false);
  const [addElev, setAddElev] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [inWaiting, setInWating] = useState(false);
  const [inWaitingStergeri, setInWaitingStergeri] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const isMobile = width <= 768;

  const fetchData = async () => {
    const querySnapshot = await getDocs(collection(db, "no-verify-scutiri"));

    let array = [];
    querySnapshot.forEach((doc) => {
      // doc.data() is never undefined for query doc snapshots

      array.push({
        ...doc.data(),
      });
    });
    setInWating(array.filter((s) => s.verified === "waiting").length > 0);

    const querySnapshot1 = await getDocs(collection(db, "no-verify-stergeri"));

    let array1 = [];
    querySnapshot1.forEach((doc) => {
      // doc.data() is never undefined for query doc snapshots

      array1.push({
        ...doc.data(),
      });
    });
    setInWaitingStergeri(
      array1.filter((s) => s.delete === "waiting").length > 0
    );
  };

  useEffect(() => {
    fetchData();
    const unsub3 = onSnapshot(collection(db, "no-verify-scutiri"), (doc) => {
      fetchData();
    });
    return unsub3;
  }, []);
  const items = [
    getItem("Clase", "clase", <ReadOutlined />),
    getItem("Orar", "orar", <ScheduleOutlined />),

    getItem("Profesori", "profesori", <UserOutlined />),

    getItem("Elevi", "profile-elevi", <UsergroupAddOutlined />, [
      {
        label: "Adauga Elev",
        key: "add-elev",
      },
      { label: "Cauta elev", key: "search-elev" },
    ]),
    // getItem("Anunțuri", "anunturi", <CarryOutOutlined />),
    getItem(
      "Scutiri și Motivări",
      "scutiri",
      inWaiting === true ? (
        <div style={{ fontSize: "30px", color: "red", fontWeight: "bold" }}>
          !
        </div>
      ) : (
        <HeartOutlined />
      )
    ),
    user.subType === "director" &&
      getItem(
        "Stergeri",
        "stergeri-note",
        inWaitingStergeri === true ? (
          <div style={{ fontSize: "30px", color: "red", fontWeight: "bold" }}>
            !
          </div>
        ) : (
          <DeleteOutlined />
        )
      ),
    getItem("Condica", "condica", <BookOutlined />),
    getItem("Feedback", "feedback", <TrophyOutlined />),
    getItem("Statistici", "statistici", <LineChartOutlined />, [
      {
        label: "Statistici Clase",
        key: "statistici-clase",
      },
      { label: "Statistici Scoala", key: "statistici-scoala" },
    ]),
    getItem("Concedii", "concedii", <CoffeeOutlined />),
    getItem("Jurnal", "changelog", <ContainerOutlined />),
    getItem(user.displayName, `profil`, <SmileOutlined />),
    getItem("Ajutor", "ajutor", <InfoCircleOutlined />),
    getItem("Export Condica", "export-condica", <BookOutlined />),
    getItem("Export Cataloage", "export", <FileOutlined />),
    getItem("Setări", "setari", <SettingOutlined />),
  ];

  if (isMobile) {
    return (
      <>
        <div
          className={`mobile-overlay ${mobileMenuOpen ? "open" : ""}`}
          onClick={() => setMobileMenuOpen(false)}
        />
        <div className={`mobile-menu ${mobileMenuOpen ? "open" : ""}`}>
          <div className="mobile-menu-header">
            <img
              src={process.env.REACT_APP_LOGO}
              alt="Logo"
              className="mobile-menu-logo"
              onClick={() => navigate("/")}
            />
            <div
              className="mobile-menu-close"
              onClick={() => setMobileMenuOpen(false)}
            >
              ×
            </div>
          </div>
          <Menu
            onClick={(e) => {
              setMobileMenuOpen(false);
              if (e.key === "search-elev") {
                setOpenSearch(true);
                return;
              }
              if (e.key === "add-elev") {
                setAddElev(true);
                return;
              }
              if (e.key === "mesaje") setOpen(true);
              else {
                navigate("/" + e.key);
              }
            }}
            theme="light"
            mode="inline"
            items={items}
            className="mobile-menu-items"
          />
        </div>
        <MobileBottomNavigation
          userType="admin"
          onMenuOpen={setMobileMenuOpen}
        />
        <AddElev
          open={addElev}
          setConfirmLoading={setConfirmLoading}
          confirmLoading={confirmLoading}
          setOpen={setAddElev}
        />
        <ProfileElevi open={openSearch} setOpen={setOpenSearch} />
        <Chats open={open} setOpen={setOpen} />
      </>
    );
  }

  return (
    <Sider
      collapsible
      collapsed={collapsed}
      onCollapse={(value) => setCollapsed(value)}
      breakpoint="lg"
      collapsedWidth={70}
    >
      <AddElev
        open={addElev}
        setConfirmLoading={setConfirmLoading}
        confirmLoading={confirmLoading}
        setOpen={setAddElev}
      />
      <ProfileElevi open={openSearch} setOpen={setOpenSearch} />

      <Chats open={open} setOpen={setOpen} />
      <div
        style={{ width: "200px", display: "flex", justifyContent: "center" }}
      >
        {" "}
        {collapsed === false && (
          <Image
            width={100}
            height={100}
            src={process.env.REACT_APP_LOGO}
            preview={false}
            onClick={() => {
              navigate("/");
            }}
          />
        )}
      </div>

      <Menu
        onClick={(e) => {
          if (e.key === "search-elev") {
            setOpenSearch(true);
            return;
          }
          if (e.key === "add-elev") {
            setAddElev(true);
            return;
          }
          if (e.key === "mesaje") setOpen(true);
          else {
            navigate("/" + e.key);
          }
        }}
        theme="dark"
        defaultSelectedKeys={["1"]}
        mode="inline"
        items={items}
      />
    </Sider>
  );
};
export default Navbar;
